var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h2',{staticClass:"sub-header",attrs:{"id":_vm.slugify(_vm.content)},domProps:{"innerHTML":_vm._s(_vm.$t(_vm.content))}})
}
var staticRenderFns = []

export { render, staticRenderFns }